import styled from '@emotion/styled';

export const LIHeaderChild = styled.li`
  dt,
  dd {
    font-size: 12px;
  }
  dt {
    color: var(--fett-text-tertiary) !important;
  }
  dd {
    color: var(--fett-text-secondary) !important;
  }
`;
